export enum DriverCardPredefinedNumbers {
  Unauthorized = '0000000000000000',
}
